










import { Component, Vue } from "vue-property-decorator";
import {
  Question,
  getQuestions,
  saveQuestion,
  copyQuestion
} from "@/api/minutes-api";
import Action from "../models/action";
import QuestionFormData from "@/api/models/QuestionFormData";
import newQuestionFormData from "@/api/models/QuestionFormData";
import VPrompt from "../components/VPrompt.vue";
import MinuteTypeList from "@/templates/MinuteTypeList.vue";

@Component({
  components: {
    MinuteTypeList,
    VPrompt
  }
})
export default class MinuteTypePage extends Vue {
  questions: Question[] = [];

  get actions(): Action[] {
    return [
      new Action({
        key: "create",
        text: "新規登録",
        variant: "default",
        click: () => {
          this.create();
        }
      })
    ];
  }

  private created() {
    this.initQuestions();
  }

  async copy(questionId: string) {
    const q = this.questions.find(q => String(q.id) === String(questionId));
    if (!q) return;
    // idを初期化して新規作成する
    const data = QuestionFormData({ ...q, id: 0 });
    const id = await copyQuestion(data);
    this.$router.push({
      name: "minute-type-edit",
      params: { questionId: String(id) }
    });
  }

  select(questionId: string) {
    this.goEditPage(questionId);
  }

  goEditPage(questionId: string) {
    const params = {
      projectId: this.$store.state.projectId,
      questionId: questionId
    };
    this.$router.push({ name: "minute-type-edit", params });
  }

  private async initQuestions() {
    this.questions = await getQuestions(this.$store.state.projectId);
  }

  private async create() {
    const q: Question = {
      id: 0,
      title: "議事録テンプレート",
      answers: [
        {
          id: 0,
          type: "0",
          question: "",
          options: []
        }
      ]
    };
    const data = newQuestionFormData(q);
    const q_id = await saveQuestion(data);
    const params = {
      projectId: this.$store.state.projectId,
      questionId: String(q_id)
    };
    this.$router.push({ name: "minute-type-edit", params });
  }
}
